import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import OTISLOGO from "../../../../assets/OTIS_Logo.png";
import {
  CenterWrapper,
  LeftPaneWrapper,
  LOGIN_COLOR,
  LOGIN_FONT_SIZE,
  LogoImgWrapper,
  LogoWrapper,
  TextFieldTitleWrapper,
} from "../forgot-password/forgot-password.styles";
import { IError } from "../../../../redux/actions/errorHandlingAction";
import { ForgotPasswordPaneProps } from "./forgot-password-pane.props";
import { ICredentialErrors } from "../../../../features/user/types/icredential-errors.interface";

const ForgotPasswordPane = ({
  userData,
  errors,
  loading,
  handleChange,
  handleSubmit,
  handleBackToLogin,
}: ForgotPasswordPaneProps) => {
  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      if (event.target.id === "password") {
        handleSubmit(event);
      }
    }
  };

  return (
    <LeftPaneWrapper>
      <LogoWrapper>
        <LogoImgWrapper src={OTISLOGO} alt="logo" />
      </LogoWrapper>
      <CenterWrapper>
        <TextFieldTitleWrapper>Email</TextFieldTitleWrapper>
        <TextField
          variant="outlined"
          margin="dense"
          value={userData.email}
          fullWidth={true}
          id="email"
          label="email"
          name="email"
          type="email"
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          helperText={(errors as ICredentialErrors).emailError}
          error={!!(errors as ICredentialErrors).emailError}
        />
        {(errors as IError).errorMessage && (
          <Typography variant="body2" color="error">
            {(errors as IError).errorMessage}
          </Typography>
        )}
        <Grid container={true} direction="row" justify="flex-end" alignItems="center">
          <Button
            style={{ fontSize: LOGIN_FONT_SIZE, color: LOGIN_COLOR }}
            onClick={handleBackToLogin}
          >
            Back to Login
          </Button>
        </Grid>
        <Button
          style={{
            fontSize: "15px",
            marginTop: "30px",
            width: "130px",
            backgroundColor: LOGIN_COLOR,
            color: "white",
          }}
          size="large"
          type="submit"
          variant="contained"
          disabled={loading}
          onClick={handleSubmit}
        >
          Send
          {loading && <CircularProgress size={30} color="secondary" />}
        </Button>
      </CenterWrapper>
    </LeftPaneWrapper>
  );
};

export default ForgotPasswordPane;
